<div class="hmn-row__align">
  <div>
    <app-unit-details-header-controls-month
      (month_change)="month_change.emit($event)"></app-unit-details-header-controls-month>
  </div>

  <div class="hmn-margin__x2-left">
    <app-unit-details-header-controls-year
      (year_change)="year_change.emit($event)"></app-unit-details-header-controls-year>
  </div>

  <div class="hmn-margin__x2-left hmn-hidden__before-lg">
    <app-shared-icon-button
      [icon]="'add'"
      [button_class]="'hmn-icon__button-accent-contrast'">
    </app-shared-icon-button>
  </div>

  <div class="hmn-margin__x2-left hmn-hidden__before-lg">
    <app-shared-icon-button
      [icon]="'refresh'"
      [button_class]="'hmn-icon__button-secondary'">
    </app-shared-icon-button>
  </div>
</div>
